'use client'

import { BeatLoader } from 'react-spinners'

import { cn } from '@/lib/utils'

type SkeletonRefetchingProps = { show?: boolean }

export function SkeletonRefetching({ show = false }: SkeletonRefetchingProps) {
  return (
    <div
      className={cn(
        !show
          ? 'hidden'
          : 'bg-[rgba(255,255,255,0.5)] absolute top-0 z-20 pt-40 w-full h-full flex justify-evenly',
      )}
    >
      <BeatLoader color="#00292D" size={16} />
    </div>
  )
}
